import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const usePrinterPreferences = create(
  persist<{ preferences: { [key: string]: string }; updatePreference: (dimensions: string, printer: string) => void }>(
    (set, get) => ({
      preferences: {},
      updatePreference: (dimensions: string, printer: string) => {
        set({ preferences: { ...get().preferences, [dimensions]: printer } });
      },
    }),
    { name: 'printer-preferences' }
  )
);

export default usePrinterPreferences;
